module.exports = __webpack_public_path__ + "img/Market Explorer.cccfc1f0.svg";